/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Permission } from '../models/Permission';

export class ListPermissionsResponse {
  /**
  * List of available user permissions.
  */
  'permissions': Array<Permission>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "permissions",
      "baseName": "permissions",
      "type": "Array<Permission>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListPermissionsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

